"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.enumerate = enumerate;
exports.default = void 0;

var _iterable = require("../../internal/iterable");

var _range = require("../range/range");

var _zip = require("../$zip/zip");

var _wrap = require("../$wrap/wrap");

function enumerate(source, start = 0) {
  return (0, _zip.zip)([(0, _wrap.wrap)((0, _range.range)(start, Infinity)), source]);
}

var _default = (0, _iterable.iterableCurry)(enumerate, {
  minArgs: 0,
  maxArgs: 1
});

exports.default = _default;